import { render, staticRenderFns } from "./GroupDetailDialog.vue?vue&type=template&id=486d3513&"
import script from "./GroupDetailDialog.vue?vue&type=script&lang=js&"
export * from "./GroupDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./GroupDetailDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports